import moment from 'moment'

/**
 * Convert a date to ISO string format (YYYY-MM-DD)
 * @param {Date} date - The date to convert
 * @returns {string} ISO formatted date string
 */
export const toIso = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

/**
 * Find the closest date (by absolute day distance) to targetIso within availableDates.
 * On a tie, the later date is preferred.
 * @param {string} targetIso - ISO date string (YYYY-MM-DD)
 * @param {string[]} availableDates - ISO date strings to search
 * @returns {string|null}
 */
export const findNearestAvailableDate = (targetIso, availableDates) => {
    if (!Array.isArray(availableDates) || availableDates.length === 0) {
        return null
    }

    const target = moment(targetIso)

    return availableDates.reduce((nearest, iso) => {
        const diff = Math.abs(moment(iso).diff(target, 'days'))

        if (!nearest || diff < nearest.diff || (diff === nearest.diff && iso > nearest.iso)) {
            return { iso, diff }
        }

        return nearest
    }, null)?.iso ?? null
}
